import React, { useEffect, useState } from 'react';
import { AbsoluteCenter } from '../../Player/styles';
import styled from '@emotion/styled';
import { IconPause, IconPlayBig } from '../../../icons';

const VastPlayControls = ({ vastRef, showPlayBtn }: { vastRef: React.RefObject<any>; showPlayBtn: boolean }) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(() => {
    const av = vastRef.current?.adVideo as HTMLVideoElement | null;
    return av ? !av.paused : true;
  });

  useEffect(() => {
    const adVideo = vastRef.current?.adVideo as HTMLVideoElement | null;
    if (!adVideo) return;

    const onPlaying = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    adVideo.addEventListener('playing', onPlaying);
    adVideo.addEventListener('pause', onPause);

    return () => {
      adVideo.removeEventListener('playing', onPlaying);
      adVideo.removeEventListener('pause', onPause);
    };
  }, [vastRef]);

  const handlePlayVideo = () => {
    const adVideo = vastRef.current?.adVideo as HTMLVideoElement | null;
    if (!adVideo) return;
    if (adVideo.paused) {
      adVideo.play();
    } else {
      adVideo.pause();
    }
  };

  return (
    <BigBtnFloatingContainer show={showPlayBtn}>
      <BigBtnFloatingButton onClick={handlePlayVideo}>
        <AbsoluteCenter>
          {isPlaying ? <IconPause /> : <IconPlayBig />}
        </AbsoluteCenter>
      </BigBtnFloatingButton>
    </BigBtnFloatingContainer>
  );
};

export default VastPlayControls;

const BigBtnFloatingContainer = styled(AbsoluteCenter)<{ show: boolean }>(({ show }) => ({
  display: show ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity .3s ease',
  direction: 'rtl',
  zIndex: 2,
}));

const BigBtnFloatingButton = styled.button(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.rgba(theme.palette.background[800][0], 0.4),
  cursor: 'pointer',
  minWidth: '6.7vw',
  height: '6.7vw',
  margin: '0 3vw',
  borderRadius: '50%',
  borderStyle: 'solid',
  borderColor: 'transparent',
  ':hover': {
    backgroundColor: theme.rgba(theme.palette.background[800][0], 0.6),
  },
  '& svg': {
    width: '3vw',
    height: '3vw',
  },
  '@media (max-width: 1000px) and (min-width: 701px)': {
    minWidth: '10vw',
    height: '10vw',
    '& svg': { width: '5vw', height: '5vw' },
  },
  '@media (max-width: 700px)': {
    minWidth: '15vw',
    height: '15vw',
    '& svg': { width: '8vw', height: '8vw' },
  },
}));
